<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-external`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M11 26a8 8 0 017.142 11.608C19.902 38.498 21.892 39 24 39c2.107 0 4.098-.502 5.858-1.392A8 8 0 0137 26a12.99 12.99 0 00-6.07-11 8.003 8.003 0 01-13.86 0A12.99 12.99 0 0011 26zm-3.968 1.052A17.259 17.259 0 017 26c0-6.497 3.644-12.142 9-15.004a8 8 0 0116 0c5.356 2.862 9 8.507 9 15.004 0 .353-.01.704-.032 1.052a8 8 0 11-8.38 13.623A16.92 16.92 0 0124 43a16.92 16.92 0 01-8.588-2.326 8 8 0 11-8.38-13.623zM24 15a4 4 0 100-8 4 4 0 000 8zm13 23a4 4 0 100-8 4 4 0 000 8zm-26 0a4 4 0 100-8 4 4 0 000 8z"/></svg>
</template>
<script>

export default {
  name: 'IconExternal',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
